module.exports = __webpack_public_path__ + "static/junk-removal-b62f7786e5ea752a53b6c284c99e5674.jpg";